<div class="flex flex-col px-4 sm:px-8 md:px-15 lg:px-32 gap-4 items-center pt-8 sm:pt-12">
  <div class="flex flex-col gap-6 sm:gap-8 items-center w-full px-3 sm:px-6 md:w-[650px] lg:w-[750px]">
    <div class="text-2xl sm:text-3xl font-extrabold text-pet-cli-color-2 text-center">
      Editar Perfil
    </div>
    <div class="text-pet-cli-color-2 text-base text-justify">

      Sabemos lo importante que son tus queridas mascotas para ti, y estamos aquí
      para ayudarte a brindarles la mejor atención posible. En esta sección, puedes
      actualizar la información de tus mascotas y tu perfil para que siempre estemos
      al tanto de sus necesidades.
    </div>
    <!-- FORMULARIO #1-->
    <div
      class="flex flex-col gap-3 items-center text-pet-color-text-1 py-3 px-6 w-full max-w-3xl h-full border-solid border-2 border-gray-200 rounded-lg shadow-lg shadow-gray-400">
      <form class="form pr-1 flex flex-col w-full gap-3 justify-center items-center scroll-auto"
        #formularioDatosUsuaario="ngForm" [formGroup]="datosDeUsuarioForm">
        <div class="text-pet-cli-color-2 text-sm text-justify bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 w-full">
          <p class="font-semibold mb-1">🔒 Por tu seguridad, sigue estos pasos para editar tus datos:</p>
          <ol class="list-decimal list-inside space-y-1">
            <li>Haz clic en <strong>Solicitar token</strong> — recibirás un código en tu correo registrado.</li>
            <li>Ingresa ese código en el campo que aparecerá.</li>
            <li>Responde tu pregunta de seguridad para confirmar tu identidad y habilitar la edición.</li>
          </ol>
        </div>

        <!-- PASO 1: Solicitar token (visible mientras no se valide el OTP) -->
        <div *ngIf="!otpValidado">
          <button (click)="solicitarOtpParaActualziacionDatosUsuario()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Solicitar token
          </button>
        </div>

        <!-- PASO 2: Pregunta de seguridad (visible solo después de validar el OTP) -->
        <div *ngIf="otpValidado" class="flex flex-col w-full gap-3 items-center">
          <div class="text-xl text-pet-cli-color-2 my-3">Seguridad</div>
          <input type="text" [formControlName]="'preguntaSeguridad'"
            readonly
            class="w-full bg-gray-100 border-2 border-pet-color-text-1 text-gray-500 text-sm rounded-lg block p-3.5 pl-6 cursor-default"
            placeholder="Pregunta de Seguridad">
          <input type="text" [formControlName]="'respuestaSeguridad'"
            [ngClass]="{'border-red-500': datosDeUsuarioForm.get('respuestaSeguridad').invalid && clickUpdate}"
            class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
            placeholder="Respuesta de seguridad" required>
          <button (click)="validarPreguntaDeseguridad()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Validar pregunta de seguridad
          </button>
        </div>

        <div class="text-xl text-pet-cli-color-2 my-6">Datos personales:</div>
        <input type="text" [formControlName]="'nombre'"
          [ngClass]="{'border-red-500': datosDeUsuarioForm.get('nombre').invalid && clickUpdate}"
          class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
          placeholder="Nombre Completo" required>
        <input type="number" [formControlName]="'numeroTelefono'"
          [ngClass]="{'border-red-500': datosDeUsuarioForm.get('numeroTelefono').invalid && clickUpdate}"
          class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
          placeholder="Número celular" required>
        <input type="text" [formControlName]="'correo'"
          [ngClass]="{'border-red-500': datosDeUsuarioForm.get('correo').invalid && clickUpdate}"
          class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
          placeholder="Correo Electrónico" required>
        <div *ngIf="preguntaSeguridadValidada">
          <button (click)="acutalizarDatosDeUsuario()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Actualizar datos personales
          </button>
        </div>
      </form>
      <br>
    </div>
    <br>

    <!-- FORMULARIO #2-->
    <div
      class="flex flex-col gap-3 items-center text-pet-color-text-1 py-3 px-6 w-full max-w-3xl h-full border-solid border-2 border-gray-200 rounded-lg shadow-lg shadow-gray-400">
      <br>
      <form class="form pr-1 flex flex-col w-full gap-3 justify-center scroll-auto"
        [formGroup]="datosMascotasRegistradasForm">
        <!--lista mascotas-->
        <span class="text-xl text-pet-cli-color-2 my-6">Datos de las Mascotas del Usuario</span>
        <div formArrayName="informacionMascotas">
          <div *ngFor="let mascota of informacionMascotas.controls; let i = index">
            <div [formGroupName]="i">
              <div class="flex flex-col gap-3 border-b border-gray-500 pb-2">
                <input type="text" formControlName="nombre"
                  class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
                  placeholder="Nombre de la mascota" required>

                <div class="flex flex-col md:flex-row gap-3 w-full">
                  <select formControlName="sexo"
                    class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
                    <option value="" selected>Sexo</option>
                    <option value="1">Hembra</option>
                    <option value="2">Macho</option>
                  </select>
                  <select formControlName="especie"
                    class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
                    <option value="" selected>Especie</option>
                    <option value="1">Perro</option>
                    <option value="2">Gato</option>
                  </select>
                </div>

                <select formControlName="idRaza"
                  class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
                  <option value="">Raza</option>
                  <option *ngFor="let raza of listaRazas" value="{{raza.id}}">{{raza.nombreRaza}}</option>
                </select>
                <select formControlName="idTalla"
                  class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
                  <option value="">Tamaño</option>
                  <option *ngFor="let talla of listaTallas" value="{{talla.id}}">{{talla.talla}}</option>
                </select>
              </div>
            </div>
          </div>
          <br>
        </div>
        <div *ngIf="preguntaSeguridadValidada">
          <button (click)="actualizarDatosMascotas()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Actualizar Datos de Mascotas
          </button>
        </div>
      </form>
      <br>
    </div>
    <br>

 <!-- FORMULARIO #3-->
<div
class="flex flex-col gap-3 items-center text-pet-color-text-1 py-3 px-6 w-full max-w-3xl h-full border-solid border-2 border-gray-200 rounded-lg shadow-lg shadow-gray-400">
<form class="form pr-1 flex flex-col w-full gap-1 scroll-auto"
  [formGroup]="datosNuevasMascotasRegistradasForm">
  <!--lista mascotas-->
  <span class="text-xl text-pet-cli-color-2 my-6">Datos de las Mascotas del Usuario</span>
  <div formArrayName="informacionNuevasMascotas">
    <div *ngFor="let mascota of informacionNuevasMascotas.controls; let i = index">
      <div [formGroupName]="i">
        <div class="flex flex-col gap-3 border-b border-gray-500 pb-2">
          <input type="text" formControlName="nombre"
            class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
            placeholder="Nombre de la mascota" required>

          <div class="flex flex-col md:flex-row gap-3 w-full">
            <select formControlName="sexo"
              class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
              <option value="" selected>Sexo</option>
              <option value="1">Hembra</option>
              <option value="2">Macho</option>
            </select>
            <select formControlName="especie"
              class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
              <option value="" selected>Especie</option>
              <option value="1">Perro</option>
              <option value="2">Gato</option>
            </select>
          </div>

          <select formControlName="idRaza"
            class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
            <option value="">Raza</option>
            <option *ngFor="let raza of listaRazas" value="{{raza.id}}">{{raza.nombreRaza}}</option>
          </select>
          <select formControlName="idTalla"
            class="w-full bg-gray-50 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5">
            <option value="">Tamaño</option>
            <option *ngFor="let talla of listaTallas" value="{{talla.id}}">{{talla.talla}}</option>
          </select>
        </div>
      </div>
    </div>
    <button (click)="removeMascota()"
      class="flex justify-center gap-2 bg-transparent w-full border border-gray-600 text-gray-500 font-semibold py-2 px-5 hover:bg-gray-100 rounded">
      <span class="material-icons">
        remove_circle
      </span>
      Quitar Nueva Mascota
    </button>
  </div>
  <!-- En este momento se están terminando los formularios para los datos personales / agregar nuevos animales-->
  <button (click)="cargarNuevaMascotaUsuario()"
    class="flex justify-center gap-2 bg-transparent w-full border border-gray-600 text-gray-500 font-semibold py-2 px-5 hover:bg-gray-100 rounded">
    <span class="material-icons">
      add_circle
    </span>
    Nueva Mascota
  </button>
</form>
<div *ngIf="preguntaSeguridadValidada">
  <div *ngIf="informacionNuevasMascotas.length > 0">
    <button (click)="confirmarAgregarMascotasNuevas()"
      class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
      Agregar Nueva Mascota
    </button>
  </div>
</div>
<br>
</div>

  </div>
</div>